(function () {
    'use strict';

    angular.module('swif.openbase')
    .component('openbaseConsumableCategoryImportForm', {
        templateUrl: 'partials/openbase/wizard_categories.html',
        controller: openbaseConsumableCategoryImportForm
    });


    function openbaseConsumableCategoryImportForm($scope, swif, $http, $q, openbase) {
        'ngInject';
        $scope.loading = {import: {}};
        $scope.contentType = 'consumable_category';
        $scope.heads = 'Nom,Services associés';
        $scope.items = {};
        //fields of the object
        $scope.fields = ['name', 'service_ids'];
        //fields for import params
        var fields = ['name', 'code', 'service_ids/.id', 'parent_id'];
        openbase.wizard.load_json($scope.items, 'json/wizard_consumable_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = openbase.wizard.pre_import_data($scope.items.selected, ['name', 'code', 'service_ids', 'parent_id']);
            openbase.wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

})();